<template>
    <el-container>
        <div class="container">
            <div class="searchBox">
                <el-form :inline="true" :model="formData" label-option="left">
                    <el-row >
                        <el-col :span="6" class="leftAlignTtem">
                            <el-form-item label="姓名">
                                <el-input v-model="formData.name" placeholder="姓名 模糊匹配"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" class="leftAlignTtem">
                            <el-form-item label="工号">
                                <el-input v-model="formData.workNo" placeholder="工号 精确匹配"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" class="leftAlignTtem">
                            <el-form-item label="合约编号">
                                <el-input v-model="formData.contractNo" placeholder="合约编号 模糊匹配"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" class="leftAlignTtem">
                            <el-form-item label="作番号">
                                <el-input v-model="formData.mfgNo" placeholder="作番号 模糊匹配"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row >
                        <el-col :span="6" class="leftAlignTtem">
                            <el-form-item label="请选择:">
                                <el-radio-group v-model="formData.type" v-removeAriaHidden >
                                    <el-radio :label="0">未完成</el-radio>
                                    <el-radio :label="1">已完成</el-radio>
                                    <el-radio :label="2">全部</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" class="leftAlignTtem">
                            <el-form-item label="注册码">
                                <el-input v-model="formData.registCode" placeholder="注册码 模糊匹配"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" class="leftAlignTtem">
                            <el-form-item label="签到时间">
                                <el-date-picker type="date" placeholder="从" v-model="formData.signInTime1" format="yyyy-MM-dd"></el-date-picker>
                                <span>-</span>
                                <el-date-picker type="date" placeholder="到" v-model="formData.signInTime2" format="yyyy-MM-dd"></el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row class="gapRow">
                        <el-col :span="24" class="">
                            <el-form-item>
                            <el-button type="primary" @click="query" icon="el-icon-search"  round >查询</el-button>
                            <el-button round @click="reset">重置</el-button>
                            <el-button type="primary" round @click="exportExcel">导出维保报表</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div class="contentBox" >
                <el-table :data="tableData" max-height="2000" @expand-change="expandColumn" ref="refTable" >
                    <el-table-column type="expand">
                        <template slot-scope="props">
                            <el-form label-position="top" class="demo-table-expand expandForm" inline>
                                <el-form-item label="签到轿厢照片">
                                    <el-image :src=" staticPath + props.row.signInImageUrl" fit="fill" style="width: 300px;height: 300px;" :preview-src-list="[staticPath + props.row.signInImageUrl]"></el-image>
                                </el-form-item>
                                <el-form-item label="签退轿厢照片">
                                    <el-image :src=" staticPath + props.row.signOutImageUrl" fit="fill" style="width: 300px;height: 300px;" :preview-src-list="[staticPath + props.row.signOutImageUrl]"></el-image>
                                </el-form-item>
                            </el-form>
                        </template>
                    </el-table-column>
                    <el-table-column prop="mfgNo" label="作番号" ></el-table-column>
                    <el-table-column prop="contractNo" label="合约编码" ></el-table-column>
                    <el-table-column prop="contractName" label="合约名称" ></el-table-column>
                    <el-table-column prop="address" label="地址信息" ></el-table-column>
                    <el-table-column prop="name" label="姓名" ></el-table-column>
                    <el-table-column prop="workNo" label="工号" ></el-table-column>
                    <el-table-column prop="signInTime" label="签到时间" ></el-table-column>
                    <el-table-column prop="signOutTime" label="签退时间" ></el-table-column>
                    <el-table-column prop="distance" label="签到距离误差" ></el-table-column>
                </el-table>
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageIndex"
                    :page-sizes="[10,20,30,40,50]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
    </el-container>
</template>

<script>
import request from '@/lib/utils'

export default {
  name: 'signRecord',
  data () {
    return {
      formData: {
        name: '',
        workNo: '',
        contractNo: '',
        mfgNo: '',
        type: 2,
        signInTime1: '',
        signInTime2: '',
        registCode: ''
      },
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      total: 0
    }
  },
  methods: {
    query () {
      const that = this
      let requestData = {}
      Object.assign(requestData, that.formData)
      requestData.pageIndex = that.pageIndex
      requestData.pageSize = that.pageSize
      request.post('/sign/queryByPageManager', requestData).then(res => {
        that.tableData = res.obj.list
        that.total = res.obj.total
      }
      ).catch(err => {
        that.$message.error(err)
      })
    },
    reset () {
      this.formData = {
        name: '',
        workNo: '',
        contractNo: '',
        mfgNo: '',
        type: 2,
        signInTime1: '',
        signInTime2: '',
        registCode: ''
      }
    },
    handleSizeChange (cureentSize) {
      this.pageSize = cureentSize
      this.query()
    },
    handleCurrentChange (currentPage) {
      this.pageIndex = currentPage
      this.query()
    },
    exportExcel () {
      if (!this.formData.signInTime1) {
        this.$message.error('请选择开始时间')
      }
      if (!this.formData.signInTime2) {
        this.$message.error('请选择结束时间')
      }
      let token = localStorage.getItem('auth-token')
      window.open(process.env.API_URL + 'sign/exportSignReport?auth_token=' + token + '&beginDay=' + this.formatDate(this.formData.signInTime1) + '&endDay=' + this.formatDate(this.formData.signInTime2), '_blank')
    },
    expandColumn (row, expandRows) {
      if (expandRows.length > 1) {
        for (let i = 0; i < expandRows.length; i++) {
          if (expandRows[i].id !== row.id) {
            this.$refs.refTable.toggleRowExpansion(expandRows[i], false)
          }
        }
      }
    },
    formatDate (date) {
      if (!date) return ''
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    }
  },
  mounted () {
    this.query()
  },
  computed: {
    staticPath () {
      return process.env.API_URL.substring(0, process.env.API_URL.length - 1)
    }
  }
}

</script>

<style scoped>

.container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .searchBox{
    width:80% ;
    margin-top: 40px;
  }

  .leftAlignTtem{
    text-align: left;
  }

  .contentBox{
    width: 80%;
    margin-top: 50px;
  }

  .gapRow{
    margin-top: 30px;
  }

  .el-link{
    padding-right: 10px;
  }

  .modelInput{
    width:80%
  }

  .shortInput{
    width: 30%;
  }

  .longInput{
    width: 390%;
  }

  .expandForm{
    margin-left: 30px;
  }

</style>



// WEBPACK FOOTER //
// src/page/subPage/SignRecord.vue